import React from 'react';
import PageTemplatePlanoAnual from '../templates/PageTemplatePlanoAnual';
import StyledGlobal from '../../../PlanoAnual2025.styled';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import { fetchStorageFile } from 'hooks/StoreFiles';
import { ConfigProvider, Image, Table } from 'antd';
import { render } from '@testing-library/react';
import { IsCustomMaxWidth, IsCustomMinWidth } from 'core/util/WindowSize';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';

const dataSource = [
    {
        key: '1',
        name: 'Jaboatão dos Guararapes (PE)',
        solucoes: 'Acelera Brasil, Circuito 360, Fórmula da Vitória, Gestão Nota 10 e Se Liga',
        estudantes: '+46 mil',
        escolas: '108',
    },
    {
        key: '2',
        name: 'Macaé (RJ)',
        solucoes: 'Acelera Brasil, Circuito 360, Fórmula da Vitória, Gestão Nota 10 e Se Liga',
        estudantes: '+29 mil',
        escolas: '53',
    },
    {
        key: '3',
        name: 'Maceió (AL)',
        solucoes: 'Acelera Brasil, Circuito 360, Fórmula da Vitória, Gestão Nota 10 e Se Liga',
        estudantes: '+39 mil',
        escolas: '90',
    },
    {
        key: '4',
        name: 'Natal (RN)',
        solucoes: 'Acelera Brasil, Gestão Nota 10 e Se Liga',
        estudantes: '+36,9 mil',
        escolas: '73',
    },
    {
        key: '5',
        name: 'Nova Iguaçu (RJ)',
        solucoes: 'Acelera Brasil, Circuito 360, Fórmula da Vitória, Gestão Nota 10 e Se Liga',
        estudantes: '+50 mil',
        escolas: '123',
    },
    {
        key: '6',
        name: 'São Luís (MA)',
        solucoes: 'Acelera Brasil, Circuito 360, Fórmula da Vitória, Gestão Nota 10 e Se Liga',
        estudantes: '+53 mil',
        escolas: '83',
    },
];

const columns = [
    {
        title: 'Parceria',
        dataIndex: 'name',
        key: 'name',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'Soluções Implementadas',
        dataIndex: 'solucoes',
        key: 'solucoes',
        width: 300,
    },
    {
        title: 'Estudantes',
        dataIndex: 'estudantes',
        key: 'estudantes',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'Escolas',
        dataIndex: 'escolas',
        key: 'escolas',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
];

const SessionAbrangenciaPlanoAnual = () => {
    const isMinWidth1500 = IsCustomMinWidth(1500);

    return (
        <>
            <PageTemplatePlanoAnual numberPage={9}>
                <div style={{ position: 'relative' }}>
                    <StyledGlobal.Title blue fontSize="32px">
                        2. ABRANGÊNCIA DO PLANO
                    </StyledGlobal.Title>
                    <StyledGlobal.Content>
                        <StyledGlobal.ContentColumn>
                            <Image
                                style={{ width: '100%' }}
                                src={fetchStorageFile('anexo_storage_files_13873950858632511596.png_2025-11-19-1763563221268.png')}
                                alt={`
                                    Mapa do Brasil destacando os seis municípios participantes em cor amarela e pontos azuis. Para cada município são apresentados dados de alfabetização e distorção idade-série. 
                                    São Luís (MA): alfabetização 57%, distorção anos iniciais 12%, distorção anos finais 24%. 
                                    Natal (RN): alfabetização — dado indisponível, distorção anos iniciais 12%, distorção anos finais 39%. 
                                    Jaboatão dos Guararapes (PE): alfabetização 55%, distorção anos iniciais 12%, distorção anos finais 18%. 
                                    Maceió (AL): alfabetização 41%, distorção anos iniciais 19%, distorção anos finais 36%. 
                                    Macaé (RJ): alfabetização 60%, distorção anos iniciais 18%, distorção anos finais 29%. 
                                    Nova Iguaçu (RJ): alfabetização 33%, distorção anos iniciais 21%, distorção anos finais 33%.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.ContentColumn>
                        <div>
                            <Image
                                style={{ width: '100%' }}
                                src={fetchStorageFile('anexo_storage_files_8179289597158583840.png_2025-11-19-1763563141292.png')}
                                alt={`Quadro retangular contendo dados educacionais do Brasil. O texto apresenta: alfabetização igual 59,2%; distorção idade-série nos anos iniciais em 8%; e distorção idade-série nos anos finais em 21%. `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <p style={{ lineHeight: '18px', alignSelf: 'center', justifySelf: 'center', position: 'relative', top: '0px' }}>
                                ¹ Rede Pública <br />² Rede Municipal
                            </p>
                        </div>
                    </StyledGlobal.Content>
                </div>
                <p>Fontes: MEC - Indicador Criança Alfabetizada (2024). MEC/Inep - Censo Escolar (2024)</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={10}>
                <StyledGlobal.Title blue fontSize="32px">
                    2.1 ATENDIMENTO
                </StyledGlobal.Title>
                <StyledGlobal.Content>
                    <ResponsiveGrid
                        templates={{
                            desktop: '1fr 1fr',
                            notebook: '1fr',
                            tablet: '1fr',
                        }}
                        gridReverse={isMinWidth1500 ? false : true}
                        styles={{ marginLeft: 0, gap: '0px' }}
                    >
                        <StyledGlobal.ContentColumn>
                            <Image
                                width={'100%'}
                                src={fetchStorageFile('anexo_storage_files_2907565622780487210.png_2025-11-19-1763563850718.png')}
                                alt={`
                                    Mapa do Brasil com seis municípios destacados em amarelo e marcadores azuis, representando redes municipais participantes do projeto. Os municípios identificados são: São Luís (MA), Natal (RN), 
                                    Jaboatão dos Guararapes (PE), Maceió (AL), Macaé (RJ) e Nova Iguaçu (RJ). Uma legenda informa: '6 redes municipais' 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />

                            <div></div>
                        </StyledGlobal.ContentColumn>
                        <StyledGlobal.TableWrapper>
                            <StyledGlobal.RowWrap>
                                <StyledGlobal.CardYellow
                                    style={{ maxWidth: '250px' }}
                                    role="img"
                                    aria-label="Retângulo amarelo contendo o texto: mais de 250 mil professores e alunos da rede pública de ensino"
                                >
                                    <div className="metrica">
                                        <span> +250 mil</span> <p>professores e alunos da rede pública de ensino</p>
                                    </div>
                                </StyledGlobal.CardYellow>
                                <StyledGlobal.CardYellow
                                    style={{ maxWidth: '320px' }}
                                    role="img"
                                    aria-label="Retângulo amarelo contendo o texto: 518 escolas da rede pública de ensino"
                                >
                                    <div className="metrica">
                                        <span> +518 escolas</span> <p>da rede pública de ensino</p>
                                    </div>
                                </StyledGlobal.CardYellow>
                            </StyledGlobal.RowWrap>

                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorTextHeading: '#0e60e8',
                                        colorBgBase: '#eae8e6',
                                    },
                                }}
                                table={{
                                    style: {
                                        background: 'none',
                                    },
                                }}
                            >
                                <Table
                                    pagination={false}
                                    dataSource={dataSource}
                                    columns={columns}
                                    scroll={{ x: 600 }}
                                    style={{ minWidth: 600 }}
                                />
                            </ConfigProvider>
                        </StyledGlobal.TableWrapper>
                    </ResponsiveGrid>
                </StyledGlobal.Content>
                <p>Fonte: MEC/Inep - Censo Escolar (2024). Rede Municipal</p>
            </PageTemplatePlanoAnual>
        </>
    );
};

export default SessionAbrangenciaPlanoAnual;
